import React from 'react';

class SMHeaderSearch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      eventType: props.eventType || ''
    };
  }
  componentDidMount() {
  }

  eventTypeDidSelect(category, e) {
    this.setState({eventType: category});
    window.location.href = Routes.search_index_path({event_type: category, with_recommend: true});
  }

  otherDidSelect(e) {
    const category = e.currentTarget.value;
    this.setState({eventType: category});
    window.location.href = Routes.search_index_path({event_type: category, with_recommend: true});
  }

  render() {

    const eventType = this.state.eventType;
    const mainGroup = ['party', 'class', 'stay'];
    const otherGroup = ['photo_shoot', 'film_shoot', 'studio', 'performance', 'sports', 'office', 'wedding', 'event', 'other'];
    const isOtherCurrent = (otherGroup.indexOf(eventType) >= 0);
    const otherText = isOtherCurrent ? I18n.t('service.event_type.' + eventType) : I18n.t('service.event_type.other');
    const buttonClassName = 'site-header__search-menu-button';
    let otherClassName = buttonClassName;
    if (isOtherCurrent) otherClassName += ' is-current';

    return (
      <div className="site-header__search sm-hide">
        <div className="site-header__search-menu sm-hide">
          <ul>
            {mainGroup.map((category, index)=>{
              let className = buttonClassName;
              if (eventType == category) className += ' is-current';
              return(
                <li key={category} className="site-header__search-menu-item">
                  <a className={className} href={Routes.search_index_path({event_type: category, with_recommend: true})}>{I18n.t('service.event_type.' + category)}</a>
                </li>
              );
            })}
            <li className="site-header__search-menu-item site-header__search-menu-item-others">
              <a className={otherClassName} href={'/event_types/other'}>{otherText}</a>
              <select
                name="others"
                value={eventType}
                className="w100pa js-select__transparent"
                onChange={this.otherDidSelect.bind(this)}>
              <option value=""></option>
              {otherGroup.map((category, index)=>{
                return(
                  <option key={category} value={category}>{I18n.t('service.event_type.' + category)}</option>
                );
              })}
              </select>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
export default SMHeaderSearch;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMHeaderSearch.jsx